import LegalPage from './LegalPage';

export default function DataCollectionConsentPage() {
  return (
    <LegalPage
      title="개인정보 수집 및 이용 동의"
      mdPath="/legal/data-collection-consent.md"
    />
  );
}
